// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"bb2c892e","281":"8e9467d7","298":"a339cca7","634":"b354cdae","671":"540a7554","787":"6034518f","938":"c657d944"}[chunkId] + ".chunk.js";
};